<ng-container *ngIf="isSelected$ | async">
    <div class="panel-container">
        <div class="stream-container">
            <div class="nb-card-header">
                <div @fadeIn *ngIf="header" class="header">{{ header }}</div>
            </div>
            <div class="message-flow">
                <div @fadeIn *ngIf="description" class="description">{{ description }}</div>
                <!-- <div class="output-items-container" 
                    ubsSequentialOutputAnimation
                    (sequenceComplete)="onAnimationSequenceComplete()">
                    <div class="output-item" *ngFor="let outputItem of outPutItems">
                        <ubs-output-item [outputItem]="outputItem" [animationState]="'inactive'"></ubs-output-item>
                    </div>
                </div> -->
                <div class="output-items-container" 
                    ubsSequentialOutputAnimation
                    (sequenceComplete)="onAnimationSequenceComplete()">
                    <div class="output-item" *ngFor="let outputItem of outPutItems">
                        <ubs-output-item [outputItem]="outputItem" 
                        [animationState]="'inactive'">
                        </ubs-output-item>
                    </div>
                </div>
                <!-- <div class="output-item" *ngFor="let outputItem of outPutItems">
                    <ubs-output-item [outputItem]="outputItem"></ubs-output-item>
                </div> -->
                <!-- <div @fadeIn *ngFor="let item of visibleItems" class="item">{{ item }}</div> -->
                 
                
            </div>
            <div class="actions">
                <div *ngIf="isLoading" class="loader">Loading...</div>
             </div>
        </div>
    </div>
</ng-container>

